import React from 'react';
import { ShieldCheck, BadgeCheck, Award } from 'lucide-react';

const badges = [
  { icon: ShieldCheck, label: '12-month workmanship guarantee' },
  { icon: BadgeCheck, label: 'Fully insured' },
  { icon: Award, label: "Auckland's only certified AHS A200 installer" },
];

// Brand names (not logos) — safe re: trademarks, and looks clean. ISCS now owns AHS (the A200).
const brands = ['Lockwood', 'Legge', 'Schlage', 'ASSA ABLOY', 'dormakaba', 'ISCS (AHS A200)'];

const TrustStrip = ({ dark = false }) => (
  <section className={dark ? 'bg-gray-950 text-white py-12 sm:py-14' : 'bg-white py-12 sm:py-14 border-y border-gray-100'}>
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="grid sm:grid-cols-3 gap-6 mb-10">
        {badges.map((b) => (
          <div key={b.label} className="flex items-center gap-3 justify-center">
            <span className={`w-11 h-11 rounded-full flex items-center justify-center flex-shrink-0 ${dark ? 'bg-white/10' : 'bg-red-50'}`}>
              <b.icon className="text-red-600" size={22} />
            </span>
            <span className={`font-semibold ${dark ? 'text-white' : 'text-gray-900'}`}>{b.label}</span>
          </div>
        ))}
      </div>
      <div className="text-center">
        <p className={`text-xs uppercase tracking-[0.2em] font-semibold mb-4 ${dark ? 'text-gray-400' : 'text-gray-500'}`}>
          Brands we install
        </p>
        <div className="flex flex-wrap justify-center items-center gap-x-8 gap-y-3">
          {brands.map((name) => (
            <span key={name} className={`text-lg font-bold ${dark ? 'text-gray-200' : 'text-gray-700'}`}>
              {name}
            </span>
          ))}
          <span className={`text-lg ${dark ? 'text-gray-500' : 'text-gray-400'}`}>&amp; more</span>
        </div>
      </div>
    </div>
  </section>
);

export default TrustStrip;
